(() => {
    const selectors = {
        link: ".js-heading-link",
        menuItems: ".js-first-level-link"
    };
    const headingLink = document.querySelector(selectors.link);
    const gender = window.genderPreference.getGenderPreference();
    const { language, country } = document.body.dataset;

    if (gender && window.genderPreference.AVAILABLE_GENDERS.includes(gender)) {
        if (country === 'it') {
            headingLink.setAttribute("href", `/collections/${gender}`);
        } else {
            headingLink.setAttribute("href", `/${language}-${country}/collections/${gender}`);
        }
        [...document.querySelectorAll(selectors.menuItems)].forEach((menuItem) => {
            menuItem.classList.remove('active-gender')
        });
        document.querySelector(`.js-first-level-link[data-gender="${gender}"]`).classList.add('active-gender');
    }
})();